<template>
    <node-view-wrapper class="banned-word" :contenteditable="false">
        <div
            class="banned-word-content"
            v-tippy="{ followCursor: true, placement: 'top-center' }"
            content="Banned Word"
        >
            <span class="material-icons">cancel</span>
            <span>{{ node.attrs.word }}</span>
        </div>
    </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-2";
import { log2 } from "../../../../../utils/log2";

const log = log2("BannedWord");
export default {
    name: "BannedWord",
    props: nodeViewProps,
    components: {
        NodeViewWrapper,
    },
    methods: {},
    mounted() {},
    beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.banned-word {
    background: red;
    width: max-content;
    padding: 2px 8px;
    border-radius: 20px;
    color: white;
    display: inline-flex;
    user-select: none;

    &-content {
        display: flex;
        align-items: center;
        gap: 3px;

        .material-icons {
            font-size: 16px;
            color: white;
        }
    }
}
</style>
